<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form label-position="raght"  :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
        
      <el-form-item  label="账户ID" prop="advertiserId">
<!--          <el-input v-model="dataForm.advertiserId" placeholder="账户ID"></el-input>-->
              <el-select style="width:300px;" filterable v-model="dataForm.advertiserId"  clearable placeholder="请选择账户" :disabled="dataForm.id">
                  <el-option
                          v-for="item in advertisers"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item>
<!--          <el-form-item label="账户名称" prop="advertiserName">-->
<!--          <el-input v-model="dataForm.advertiserName" placeholder="账户名称"></el-input>-->
<!--      </el-form-item>-->
<div class="inline-box">
          <!-- <el-form-item  label="省份" prop="province">
         <el-input v-model="dataForm.province" placeholder="省份"  :disabled="dataForm.id"></el-input>
              <el-select style="width:150px;" v-model="dataForm.province" filterable clearable placeholder="请选择省份">
                  <el-option
                          v-for="item in provinces"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>
      </el-form-item> -->
          <el-form-item  label="城市" prop="city">

              <el-select style="width:150px;" v-model="dataForm.city" filterable clearable :disabled="dataForm.id" placeholder="请选择城市">
                  <el-option
                          v-for="item in citys"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
              </el-select>

      </el-form-item>
   
          <el-form-item  label="平均单价" prop="avgCost">
              <el-input style="width:150px;" v-model="dataForm.avgCost" placeholder="平均单价"  :disabled="dataForm.id" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
      </el-form-item>
          <el-form-item  label="调整价" prop="manuAvgCost">
          <el-input style="width:150px;" v-model="dataForm.manuAvgCost" placeholder="调整价" oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
      </el-form-item>
      <!-- <el-form-item   label="统计日期" prop="date">
          <el-date-picker
                  style="width: 180px;"
                  v-model="dataForm.date"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :disabled="dataForm.id">
          </el-date-picker>
      </el-form-item> -->
    </div>
<!--          <el-form-item label="状态（开1、关0）" prop="status">-->
<!--          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>-->
<!--      </el-form-item>-->

      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
        provinces:[],
        citys:[],
        advertisers:[],
      dataForm: {
        id: '',
        advertiserId: '',
        advertiserName: '',
        province: '',
        city: '',
        avgCost: '',
        manuAvgCost: '',
        date: '',
        status: '',
        createBy: '',
        createTime: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
      
        cityWidth:'150px'
      }
    }
  },
  mounted(){
   
  },
  computed: {
    dataRule () {
      return {
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // advertiserName: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // province: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        avgCost: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // manuAvgCost: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // date: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
        this.getAdvertisersOptions();
        this.getProvinceOptions();
        this.getCityOptions();
      
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取当前时间
    getNowTime(){
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      let time = `${year}-${this.addZero(month)}-${this.addZero(day)} ${this.addZero(hour)}:${this.addZero(minute)}:${this.addZero(second)}`
      return time
    },
    addZero(s){
      return s < 10 ? `0${s}` : s
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/scopecitycost/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
      //初始化广告主账户下拉框中的选项
      async getAdvertisersOptions() {
          this.$http.get(`/sys/rdadvertiser/list`).then(({data: res}) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.advertisers = [];
              if (res.data != null) {
                  res.data.forEach(element => {
                      this.advertisers.push({label: element.advertiserName, value: element.advertiserId})
                  })
              }
          }).catch(() => {
          })
      },
    //初始化下拉框中的选项
    async getProvinceOptions() {
        this.$http.get(`/sys/dict/data/list?dataType=landing_page_province`).then(({ data: res }) => {
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.provinces=[];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.provinces.push({label:element.dictLabel,value:element.dictValue})
                    console.log(this.provinces,'provinces')
                })
            }
        }).catch(() => {})
    },
    //初始化下拉框中的选项
    async getCityOptions() {
        this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.citys=[];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.citys.push({label:element.dictLabel,value:element.dictValue})
                })
               
            }
        }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.id ? '' : this.dataForm.date = this.getNowTime() 
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/scopecitycost/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped>
   .inline-box{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
   }
   .el-form-item{
    margin-right: 40px;
   }
   
</style>
